var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(1 0 0 -1 8 11)",
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(1 0 0 -1 14 11)",
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 13.5C15.3219 13.5 15.3789 13.5297 15.4108 13.5635C15.4383 13.5927 15.4455 13.6202 15.4392 13.6533C15.1335 15.2741 13.7094 16.5 12 16.5C10.2906 16.5 8.86648 15.2741 8.56077 13.6533C8.55453 13.6202 8.56167 13.5927 8.58925 13.5635C8.62111 13.5297 8.67813 13.5 8.75 13.5C8.86478 13.5 9.04849 13.6121 9.1333 13.8866C9.51135 15.1101 10.6511 16 12 16C13.3489 16 14.4886 15.1101 14.8667 13.8866C14.9515 13.6121 15.1352 13.5 15.25 13.5Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileWhite);
export default __webpack_public_path__ + "static/media/smile_white.b2b6a5bbbd54cd03ae8ffe132dba6732.svg";
export { ForwardRef as ReactComponent };